import { css } from '@emotion/react';

export const dialogStyle = css`
	.bp3-button {
		margin-left: 5px;
	}

	.bp3-dialog-footer {
		text-align: right;
	}

	background: white;
`;
